import React, { lazy, Suspense, useEffect, useState } from 'react'
import HeroSection from './HeroSection'
import TrustBar from './TrustBar'
import CTASection from '../../common/CTASection'

// Sections below the first screen are a separate chunk (see HomeRest.js).
const HomeRest = lazy(() => import('./HomeRest'))

// Keeps the footer far below the screen until the sections above mount.
const Placeholder = () => <div aria-hidden="true" style={{ minHeight: '4000px' }} />

const Index = () => {
    // The top of the page (hero, trust bar, CTA band) is drawn first. The
    // sections below the fold are loaded and mounted right after the first
    // paint, when the browser is idle, so the hero does not wait for them.
    const [showRest, setShowRest] = useState(false)

    useEffect(() => {
        const show = () => setShowRest(true)
        if ('requestIdleCallback' in window) {
            const id = window.requestIdleCallback(show, { timeout: 1500 })
            return () => window.cancelIdleCallback(id)
        }
        const id = setTimeout(show, 200)
        return () => clearTimeout(id)
    }, [])

    return (
        <div>
            <HeroSection />
            <TrustBar />
            <CTASection />
            {showRest ? (
                <Suspense fallback={<Placeholder />}>
                    <HomeRest />
                </Suspense>
            ) : (
                <Placeholder />
            )}
        </div>
    )
}

export default Index
